export const roleEnum = {
  owner: "owner",
  athlete: "athlete",
};
